"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rest = void 0;
var safe_slice_1 = require("./safe-slice");
var rest = function (array) { return (0, safe_slice_1.safeSlice)(array, 1, array.length); };
exports.rest = rest;
